import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLookupData } from "../../redux/slices/lookupSlice";
import { Box, IconButton } from "@mui/material";
import SelectDropdown from "../SelectDropdown/SelectDropdown";
import ActionButton from "./ActionButton/ActionButton";
import UnitFormModal from "../UnitFormModal/UnitFormModal";
import city from './../../assets/images/signin/city.png';
import district from './../../assets/images/signin/district.png';
import project from './../../assets/images/signin/project.png';
import building from './../../assets/images/signin/building.png';
import floor from './../../assets/images/signin/floor.png';
import unit from './../../assets/images/signin/unit.png';
import { FaPlus } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import SuccessSnackbar from "../SuccessSnackbar/SuccessSnackbar";
const Step2 = ({ formData, customHandleChange, formik, handleNext, handleBack, handleOpenUnit, handleCloseUnit, openModal, setFormData, t, language, direction }) => {
    const dispatch = useDispatch();
    const [newUnitAdded, setNewUnitAdded] = React.useState(false);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [newUnitName, setNewUnitName] = useState("");
    const equipmentName = formData.equipments[0]?.equipmentNameEn || "";
    const { lookups, loading, error } = useSelector((state) => state.lookup);
    const fetchIfNotLoaded = (lookupNumber, parentId) => {
        dispatch(fetchLookupData({ lookupNumber, parentId, language,allowNotSelectedUnitsOnly:true }));
    };
    useEffect(() => {
        fetchIfNotLoaded(1, null); // Always fetch city
        if (formik.values.city) fetchIfNotLoaded(2, formik.values.city);
        if (formik.values.district) fetchIfNotLoaded(3, formik.values.district);
        if (formik.values.project) fetchIfNotLoaded(4, formik.values.project);
        if (formik.values.building) fetchIfNotLoaded(5, formik.values.building);
        if (formik.values.floor) fetchIfNotLoaded(6, formik.values.floor);
    }, [
        formik.values.city,
        formik.values.district,
        formik.values.project,
        formik.values.building,
        formik.values.floor,
    ]);
    const handleClearUnit = () => {
        formik.setFieldValue("unit", "");
        setNewUnitAdded(false);
    };
    const handleClearUnit2 = () => {
        setNewUnitName(""); // Clear the newly added unit name
        setFormData((prevData) => ({
            ...prevData,
            equipments: [
                {
                    equipmentNameAr: "",
                    equipmentNameEn: "",
                    descriptionAr: "",
                    descriptionEn: "",
                    floorFk: 0, // Reset floorFk to 0
                },
            ],
        }));
    };
    const handleFormSubmit = (newUnit) => {
        setFormData((prevData) => ({
            ...prevData,
            equipments: [
                {
                    ...prevData.equipments[0],
                    equipmentNameAr: newUnit.unitNameArabic,
                    equipmentNameEn: newUnit.unitNameEnglish,
                    descriptionAr: newUnit.descriptionArabic,
                    descriptionEn: newUnit.descriptionEnglish,
                    floorFk: formik.values.floor || 0,
                },
            ],
        }));
        handleCloseUnit();
        // setSnackbarMessage(`Unit "${newUnit.unitNameEnglish}" added successfully!`);
        // setOpenSnackbar(true);
        setNewUnitAdded(true);
        setNewUnitName(newUnit.unitNameEnglish);
    };
    // Configuration array for SelectDropdown fields
    const selectFields = [
        {
            name: "city",
            label: t.city,
            value: formik.values.city,
            options: lookups[1] || [],
            imageSrc: city,
            error: formik.errors.city,
            touched: formik.touched.city,
        },
        {
            name: "district",
            label: t.district,
            value: formik.values.district,
            options: formik.values.city ? (lookups[2] || []) : [],
            imageSrc: district,
            error: formik.errors.district,
            touched: formik.touched.district,
            message: formik.values.city ? "" : t.cityMessage,
        },
        {
            name: "project",
            label: t.unitDetails.project,
            value: formik.values.project,
            options: formik.values.district ? (lookups[3] || []) : [],
            imageSrc: project,
            error: formik.errors.project,
            touched: formik.touched.project,
            message: formik.values.district ? "" : t.districtMessage,
        },
        {
            name: "building",
            label: t.building,
            value: formik.values.building,
            options: formik.values.project ? (lookups[4] || []) : [],
            imageSrc: building,
            error: formik.errors.building,
            touched: formik.touched.building,
            message: formik.values.project ? "" : t.projectMessage,
        },
        {
            name: "floor",
            label: t.floor,
            value: formik.values.floor,
            options: formik.values.building ? (lookups[5] || []) : [],
            imageSrc: floor,
            error: formik.errors.floor,
            touched: formik.touched.floor,
            message: formik.values.building ? "" : t.buildingMessage,
        },
        {
            name: "unit",
            label: t.unit,
            value: formik.values.unit,
            options: formik.values.floor ? (lookups[6] || []) : [],
            imageSrc: unit,
            error: formik.errors.unit,
            touched: formik.touched.unit,
            message: formik.values.floor ? "" : t.floorMessage,
            disabled: equipmentName
            // disabled: newUnitAdded || !formik.values.floor
        },
    ];
    return (
        <>
            {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}> */}
            {/* Render SelectDropdown components dynamically */}
            {selectFields.map((field, index) => (
                <SelectDropdown
                    disabled={field.disabled}
                    key={index}
                    name={field.name}
                    label={field.label}
                    value={field.value}
                    onChange={formik.handleChange}
                    onClear={field.name === "unit" ? handleClearUnit : undefined}
                    onBlur={formik.handleBlur}
                    options={field.options.length > 0 ? field.options : []}
                    error={field.error}
                    touched={field.touched}
                    imageSrc={field.imageSrc}
                    required
                    helperText={field.message}
                    t={t}
                    direction={direction}
                // sx={{ flex: "1 1 48%" }}
                />
            ))}
            {/* </Box> */}
            {formik.values.unit === "" && !equipmentName && (
                <Box
                    sx={{
                        mb: 2,
                        fontStyle: "italic",
                        color: "gray",
                        fontSize: "12px",
                        textAlign: "center",
                        width: "100%",
                        margin: "0 auto",
                    }}
                >
                    {t.chooseOrAddUnit}
                </Box>
            )}
            {/* Display new unit name with a close icon */}
            {equipmentName ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 2,
                        mb: 2,
                        mt: 2,
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                    }}
                >
                    {/* <span>{newUnitName}</span> */}
                    <span>{equipmentName || "No name set"}</span>
                    <IconButton
                        onClick={handleClearUnit2}
                        size="small"
                        aria-label="Clear Unit"
                        color="gray"
                    >
                        <FaTimes />
                    </IconButton>
                </Box>
            ) : (
                <>
                    {/* Button to open the Unit modal */}
                    <ActionButton
                        onClick={handleOpenUnit}
                        label={t.addNewUnit}
                        color="var(--custom-gold)"
                        hovercolor="var(--custom-gold-dark)"
                        icon={<FaPlus style={{ marginRight: "4px" }} />}
                        aria-label="Add New Unit"
                        sx={{ mb: 2 }}
                        disabled={formik.values.unit !== "" || formik.values.floor === ""} // Disable if a unit is selected
                    />
                </>
            )}
            {/* Modal Component for adding a new unit */}
            <UnitFormModal
                open={openModal}
                handleClose={handleCloseUnit}
                title={t.addNewUnit}
                handleFormSubmit={handleFormSubmit}
                formik={formik}
                t={t}
                direction={direction}
                customHandleChange={customHandleChange}

            />
            {/* Success Snackbar */}
            <SuccessSnackbar
                open={openSnackbar}
                message={snackbarMessage}
                onClose={() => setOpenSnackbar(false)}
                severity={snackbarSeverity}
            />
            {/* Navigation buttons */}
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "16px", flexDirection: { xs: "column", md: "row" } }}>
                <ActionButton onClick={handleBack} label={t.back} color="var(--back-color)" />
                <ActionButton
                    onClick={handleNext}
                    label={t.next}
                    color="var(--primary-color)"
                    hovercolor="var(--primary-color-dark)"
                    disabled={
                        (!formik.values.unit && !equipmentName) || !formik.isValid
                    }
                />
            </Box>
        </>
    );
};

export default Step2;
